import React from "react";
import { Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import QuestionsTable from "../components/QuestionsTable";
import QuestionChart from "../components/QuestionChart";

const BreakdownPage = ({ data, prevData }) => {
  // Optional: Build the data array for your existing QuestionsTable
  // (If you still want the table)
  const questionsData =
    data?.questions?.map((q, idx) => {
      // Convert to an out-of-100 "percentage"
      const scoreOutOfHundred = q.overallAverage * 10;
      const prevScoreOutOfHundred = prevData
        ? prevData?.questions?.[idx]?.overallAverage * 10
        : 0;
      return {
        question: `${idx + 1}. ${q.questionText}`,
        score: parseFloat(scoreOutOfHundred.toFixed(0)), // e.g. 6.85 * 10 => 68.5 => "69"
        normAverage: q.normAverage,
        change: prevData
          ? `${parseFloat(
              (scoreOutOfHundred - prevScoreOutOfHundred).toFixed(1)
            )}%`
          : "--",
        questionAnalysis: [],
      };
    }) || [];

  return (
    <Page style={styles.page}>
      {/* Page Title */}
      <View style={styles.section}>
        <Text style={styles.title}>
          {data?.factorTitle || data?.outcomeTitle} Analysis
        </Text>
      </View>

      {/* (A) Questions Table (if you want to keep it) */}
      <View style={styles.tableSection}>
        <View style={styles.table}>
          <QuestionsTable data={questionsData} />
        </View>
      </View>
      <View style={styles.titleWrapper}>
        <Text style={styles.secondaryTitle}>
          Segmented {data?.factorTitle || data?.outcomeTitle} Question Analysis
        </Text>
      </View>

      {/* (B) Render a chart for each question, passing the entire question object */}
      {data?.questions?.map((q, idx) => {
        const prevQuestion = prevData?.questions?.[idx];
        return (
          <QuestionChart key={idx} question={q} prevQuestion={prevQuestion} />
        );
      })}
    </Page>
  );
};

// Styles for the Page
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#F8FAFF",
    padding: 40,
  },
  section: {
    marginBottom: 20,
  },
  title: {
    fontSize: 28,
    color: "#2A3039",
    fontFamily: "Outfit",
    fontWeight: 400,
    marginBottom: 10,
    letterSpacing: -0.4,
  },
  secondaryTitle: {
    fontSize: 21,
    color: "#2A3039",
    fontFamily: "Outfit",
    fontWeight: 400,
    marginBottom: 10,
    letterSpacing: -0.4,
  },
  tableSection: {
    marginBottom: 20,
  },
  table: {
    borderWidth: 1,
    borderColor: "#EAFBF7",
  },
  titleWrapper: {
    marginBottom: 20,
  },
});

export default BreakdownPage;